const INITIAL_STATE = {
    countries: null,
    states: {},
    cities: {},
    countriesStatus: 'done',
    statesStatus: 'done',
    citiesStatus: 'done',
    me: {
        lat: null,
        lng: null
    }
}

export default (state = INITIAL_STATE, action) => {
    
    switch (action.type) {
        case 'LOCATION_COUNTRIES': {
            var countries = action.payload
            return { ...state, countries }
        }
        case 'LOCATION_COUNTRIES_STATUS':
            return { ...state, countriesStatus: action.payload }
        case 'LOCATION_STATES': {
            var states = state.states
            states[action.payload.country] = action.payload.states
            return { ...state, states }
        }
        case 'LOCATION_STATES_STATUS':
            return { ...state, statesStatus: action.payload }

        case 'LOCATION_CITIES': {
            var cities = state.cities
            cities[action.payload.state] = action.payload.cities
            return { ...state, cities }
        }
        case 'LOCATION_CITIES_STATUS':
            return { ...state, citiesStatus: action.payload }
        case 'CLEAR_LOCATION_DATA':
            return { ...state, countries: {}, states: {}, cities: {}}
        case 'MY_LOCATION':
            return { ...state, me: action.payload }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/locationReducer.js